export default "__VITE_ASSET__BYQpsjJq__"